import api from "../js/api";
export default {
  name: "codewrap",
  props: {
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    reg: {
      type: String,
      default: ""
    },
    mb: {
      type: String,
      default: ""
    }
    // inputCodePlaceholder: {
    //  type:String,default:'userSign.inputCode'
    // }
  },
  inject: ['inputCodePlaceholder'],
  data: function data() {
    return {
      code: "",
      codeSrc: "",
      codeError: ""
    };
  },
  components: {},
  methods: {
    codeInput: function codeInput() {
      if (!this.code) {
        this.codeError = this.$t(this.$loginLangPrefix("userSign.codeError"));
      } else {
        this.codeError = "";
      }
      this.$emit("changeCode", this.code);
      this.$emit("changeCodeError", this.codeError);
    },
    codeBlur: function codeBlur() {
      // if (this.code && !this.reg) {
      //     api.checkVerify(this.code).then((data) => {
      //         this.codeError = '';
      //         this.$emit('changeCodeError', this.codeError);
      //     }).catch((response) => {
      //         this.codeError = this.$t(this.$loginLangPrefix('userSign.codeError'));
      //         this.$emit('changeCodeError', this.codeError);
      //     });
      // }
    },
    getVerify: function getVerify() {
      var _this = this;
      if (this.type === "phone") {
        api.mobileCaptcha(this.name).then(function (data) {
          _this.codeSrc = data.captcha;
        });
      } else {
        api.emailCaptcha(this.name).then(function (data) {
          _this.codeSrc = data.captcha;
        });
      }
      // if (this.reg && this.name) {
      //     api.emailCaptcha(this.name).then((data) => {
      //         this.codeSrc = data.captcha;
      //     });
      // } else {
      //     this.codeSrc = api.getVerify();
      // }
    },
    next: function next() {
      this.$emit("btnSure");
    }
  },
  watch: {
    // codeError(val) {
    //     this.$emit('changeCodeError', val);
    // },
    name: function name(val) {
      if (val) {
        this.getVerify();
      }
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    // this.codeSrc = this.getVerify();
    this.getVerify();
    console.log(this.inputCodePlaceholder, 'inputCodePlaceholder');
  },
  beforeDestroy: function beforeDestroy() {}
};